import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
const messages = defineMessages({
    tiktok_help_title: 'Hey TikTokers!',
    tiktok_help_question: 'Is the button at the top not working?',
    tiktok_help_hint: 'Tap and hold for 2 sec to open the link',
    tiktok_help_cta: 'Tap and hold',
});
// FOR TESTING
const ALLOWED_USERNAME = 'dolunayozeren';
const TIKTOK_AGENT_REGEX = /tiktok|ttwebview|bytedance|musical\.ly|aweme/;
const TikTokBanner = ({ username, deeplink, onClick }) => {
    const isVisible = useMemo(() => {
        if ((username === null || username === void 0 ? void 0 : username.toLowerCase()) !== ALLOWED_USERNAME)
            return false;
        if (typeof navigator === 'undefined' || !navigator.userAgent)
            return false;
        const ua = navigator.userAgent.toLowerCase();
        return TIKTOK_AGENT_REGEX.test(ua);
    }, [username]);
    if (!isVisible)
        return null;
    return (_jsxs(Card, { children: [_jsxs(Title, { children: [_jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_title)), "\u00A0", _jsx(Question, { children: _jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_question)) })] }), _jsx(Hint, { children: _jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_hint)) }), _jsxs(CTA, { href: deeplink, onClick: onClick, children: [_jsx(FormattedMessage, Object.assign({}, messages.tiktok_help_cta)), _jsx(Arrow, { children: "\u2197" })] })] }));
};
const m = '1260px';
const Card = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px auto 32px;
  padding: 20px 16px;
  width: calc(100% - 32px);
  max-width: 700px;
  border-radius: 24px;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.35);
  color: #ffffff;

  @media (min-width: ${m}) {
    display: none;
  }
`;
const Title = styled.h3 `
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  margin: 6px 0 6px;
  text-align: center;
  color: #47c2ff;
`;
const Question = styled.span `
  color: #ffffff;
`;
const Hint = styled.p `
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
  margin: 6px 0 12px;
  text-align: center;
`;
const CTA = styled.a `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 20px;
  border-radius: 28px;
  background: #ffffff;
  color: #001430 !important;
  font-weight: 700;
  text-decoration: none;
  min-width: 220px;
`;
const Arrow = styled.span `
  margin-left: 8px;
`;
export default TikTokBanner;
